import {
  Col, Flex, Row
} from "antd";
import { ReactNode } from "react";
import Background from "./background";
import Container from "../container";

import classes from "./heroScreen.module.css";

const HeroScreen = ({
  imgSrc,
  children,
  noBackground = false
} : {
  imgSrc?: string,
  children: ReactNode,
  noBackground?: boolean
}) => {
  const isAlternativeVersion = imgSrc === undefined;

  return (
    <Flex
      vertical
      justify="center"
      className={classes.root}
    >
      {!noBackground && <Background alternative={isAlternativeVersion} />}
      <Container
        style={{
          height: "100%",
          overflow: "visible",
        }}
      >
        <Row
          align="stretch"
//           gutter={[64, 40]}
          className="relative h-full z-10"
        >
          <Col span={24} lg={isAlternativeVersion ? undefined : 16}>
            {children}
          </Col>
          {!isAlternativeVersion && (
          <Col
            span={24}
            lg={8}
            className={classes.imageContainer}
          >
            <Flex
              align="end"
              justify="center"
              className="h-full"
            >
              <img
                src={imgSrc}
                alt="hero"
                className={classes.image}
              />
            </Flex>
          </Col>
          )}
        </Row>
      </Container>
    </Flex>
  );
};

export default HeroScreen;
